import { useState, useEffect } from 'react';
import axiosInstance from '../services/axiosComman';


const UseGetInsideData = ({page="", pageCount="", url,search=""}) => {
  
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(true)

  async function getData() {
    setLoading(true)
    let params;
    if(page == "" && pageCount == ""){
       params = {}
    }else if(search !=""){
      params = {
        page: page,
        per_page: pageCount,
        search:search
      }
    }else{
      params = {
        page: page,
        per_page: pageCount
      }
    }
    try {
      const res = await axiosInstance.get(url, { params });
      if(res.data){
        setLoading(false)
        setData(res?.data);
        (res?.data?.total_record||res?.data?.total) ? setTotalCount(res?.data?.total_record||res?.data?.total):setTotalCount(0)
      }else{
        setLoading(false)
        console.log(res.data?.msg||res.data?.error);
        
      }
    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  }
  useEffect(() => {
      getData()
  }, [url,page,pageCount]);

  return { data, totalCount , getData,isLoading };
};

export default UseGetInsideData;